import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const o=i("crypto",t`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            static
            fill="none">
            <g clip-path="url(#clip0_10272_718)">
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="#0C2A92" />
                <path
                    d="M20.9299 15.5204C19.5599 19.2204 15.9999 21.8604 11.8199 21.8604C6.45986 21.8604 2.10986 17.5104 2.10986 12.1504C2.10986 6.79043 6.45986 2.44043 11.8199 2.44043C15.9899 2.44043 19.5499 5.07043 20.9199 8.76043H17.5999C16.4399 6.78043 14.2799 5.45043 11.8199 5.45043C8.11986 5.45043 5.11986 8.45043 5.11986 12.1504C5.11986 15.8504 8.11986 18.8504 11.8199 18.8504C14.2899 18.8504 16.4499 17.5104 17.6099 15.5204H20.9299Z"
                    fill="white" />
                <path
                    d="M21.5301 10.9596L18.6101 13.3396H14.4501C13.9701 14.5596 12.7801 15.4196 11.3901 15.4196C9.56008 15.4196 8.08008 13.9396 8.08008 12.1196C8.08008 10.2996 9.56008 8.80957 11.3901 8.80957C12.8001 8.80957 14.0101 9.69957 14.4801 10.9596H21.5301Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_10272_718">
                    <rect
                        width="24"
                        height="24"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as Crypto};
